import { Sparkles, TrendingUp, Landmark, Receipt, PieChart, Layers, PiggyBank } from 'lucide-react';

export const CHAT_CATEGORIES = [
  {
    id: 'general', icon: Sparkles, en: 'General', sw: 'Jumla',
    starters: {
      en: ['Where should a beginner with TZS 500,000 start?', 'Compare stocks, bonds, T-bills and UTT funds for me', 'How diversified is my portfolio and why does it matter?'],
      sw: ['Mwanzo mwenye TZS 500,000 aanzie wapi?', 'Linganisha hisa, hatifungani, T-bills na UTT', 'Portfolio yangu ina mseto kiasi gani na kwa nini ni muhimu?'],
    },
  },
  {
    id: 'stocks', icon: TrendingUp, en: 'Stocks', sw: 'Hisa',
    starters: {
      en: ['Which DSE banking stocks pay the best dividends and why?', 'Analyze CRDB vs NMB using today’s prices', 'How do I open a CDS account and buy my first shares?'],
      sw: ['Hisa zipi za benki DSE zinatoa gawio bora na kwa nini?', 'Chambua CRDB dhidi ya NMB kwa bei za leo', 'Nafunguaje akaunti ya CDS na kununua hisa za kwanza?'],
    },
  },
  {
    id: 'bonds', icon: Landmark, en: 'Bonds', sw: 'Hatifungani',
    starters: {
      en: ['2-year vs 10-year Treasury bond: which suits me and why?', 'How do bond coupons work? Show a TZS example', 'Can I sell a bond before it matures? How?'],
      sw: ['Hatifungani ya miaka 2 dhidi ya 10: ipi inanifaa na kwa nini?', 'Riba ya hatifungani inafanyaje kazi? Nipe mfano wa TZS', 'Naweza kuuza hatifungani kabla ya kuiva? Vipi?'],
    },
  },
  {
    id: 'tbills', icon: Receipt, en: 'T-Bills', sw: 'T-Bills',
    starters: {
      en: ['Which T-bill gives the best yield right now?', 'How does discount pricing work on a 364-day T-bill?', 'Step by step: how do I bid in a BoT auction?'],
      sw: ['T-bill ipi ina riba bora sasa hivi?', 'Bei ya punguzo inafanyaje kazi kwa T-bill ya siku 364?', 'Hatua kwa hatua: natoaje zabuni kwenye mnada wa BoT?'],
    },
  },
  {
    id: 'cis', icon: PieChart, en: 'CIS / UTT', sw: 'CIS / UTT',
    starters: {
      en: ['Compare all 6 UTT AMIS funds for my goal', 'Liquid Fund vs Bond Fund: where should my emergency savings go?', 'What is NAV and how do I calculate my units?'],
      sw: ['Linganisha mifuko yote 6 ya UTT AMIS kwa lengo langu', 'Mfuko wa Ukwasi au Mfuko wa Hatifungani: akiba yangu ya dharura iende wapi?', 'Thamani Halisi ya Kipande (NAV) ni nini na nahesabuje vipande vyangu?'],
    },
  },
  {
    id: 'etfs', icon: Layers, en: 'ETFs', sw: 'ETF',
    starters: {
      en: ['How does the iTrust DSE ETF work and what does it cost?', 'ETF vs buying individual DSE stocks: pros and cons', 'Can I invest in foreign ETFs from Tanzania?'],
      sw: ['ETF ya iTrust DSE inafanyaje kazi na gharama yake?', 'ETF dhidi ya kununua hisa moja moja: faida na hasara', 'Naweza kuwekeza kwenye ETF za nje nikiwa Tanzania?'],
    },
  },
  {
    id: 'fprf', icon: PiggyBank, en: 'FPRF / Faida', sw: 'FPRF / Faida',
    starters: {
      en: ['Which FPRF retirement plan fits my age and why?', 'How does the Faida Fund work and how do I pay via GePG?', 'What happens to my money during the FPRF lock-in?'],
      sw: ['Mpango upi wa FPRF unafaa umri wangu na kwa nini?', 'Faida Fund inafanyaje kazi na nalipaje kwa GePG?', 'Nini hutokea kwa pesa zangu wakati wa kufungiwa FPRF?'],
    },
  },
];

export const getCategory = (id) => CHAT_CATEGORIES.find((c) => c.id === id) || CHAT_CATEGORIES[0];
